import styled from 'styled-components';
import {
  Select,
  MenuItem,
} from '@mui/material';

import { ReactComponent as EditIcon } from '../../../../../../../../../assets/icons/edit_icon.svg';
import colors from '../../../../../../../../../styles/colors';

const ClientGoalEditIcon = styled(EditIcon)`
  height: 14px;
  width: 14px;
  cursor: pointer;
  flex-shrink: 0;

  > path {
    stroke: ${colors.base.secondary2};
  }
`;

const ClientGoalWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 14px;
`;

const ClientGoalContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  line-height: 15px;
  color: ${colors.shades.beta1};
  width: Calc(100% - 115px);
`;

const ClientGoalSelect = styled(Select)`
  .MuiSelect-select {
    font-size: 13px;
    line-height: 15px;
    padding: 4px 8px;
    color: ${colors.shades.beta1};
  }
  .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${colors.shades.secondary6};
    border-radius: 4px;
  }
  min-width: 140px;
  height: 28px;
`;

const ClientGoalMenuItem = styled(MenuItem)`
  font-size: 13px;
  line-height: 15px;
  color: ${colors.shades.beta1};
  padding: 6px 12px;
`;

export {
  ClientGoalEditIcon,
  ClientGoalWrapper,
  ClientGoalContent,
  ClientGoalSelect,
  ClientGoalMenuItem,
};
